import _isPlainObject from "lodash/isPlainObject";
import { mergeComponentVariables, deepmerge } from '@fluentui/styles';
/**
 mergeComponentVariables() is always creating a function even if the arguments are undefined we have this temporary
 fix in place to avoid creating empty function because it is breaking caching we should either fix
 mergeComponentVariables(), or handle this in a more generic way.
 */
export function mergeVariablesOverrides(variables, overrides) {
  if (variables && overrides) {
    if (_isPlainObject(variables) && _isPlainObject(overrides)) {
      return deepmerge(variables, overrides);
    }
    return mergeComponentVariables(variables, overrides);
  }
  return variables || overrides;
}
//# sourceMappingURL=mergeVariablesOverrides.js.map
